<!--

    Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<ods-dropdown-menu buttonTestId="user-settings-button" buttonTooltip="Einstellungen">
  <ods-icon button-content name="settings" fill="neutral" />
  <ods-dropdown-menu-item padding="large" class="w-72">
    <alfa-user-settings-darkmode-container />
  </ods-dropdown-menu-item>
  @if (apiRoot.resource | hasLink: apiRootLinkRel.CURRENT_USER) {
    <ods-dropdown-menu-item padding="bottom-large" class="w-72" data-test-id="email-benachrichtigung-toggle">
      <alfa-user-settings-email-benachrichtigung-container />
    </ods-dropdown-menu-item>
  }
</ods-dropdown-menu>
